import { createStore, applyMiddleware } from 'redux';
import rootReducer from './rootReducer';


//create middleware
const myLogger = (store) => (next) => (action) => {
    const currentState = store.getState();

    const stateSize = currentState.bookingReducer.bookInfos.length;
    
    switch (action.type) {
        case 'booking/Add_book_info':
            if(stateSize === 3) {
                alert('Maximum store capability is 3 flight booking requests. Please delete one of the requests and try again.');
                break;
            } else {
                return next(action);
            }
        case 'booking/Remove_book_info':
            return next(action);
        default:
            return next(action);
    }
}

const store = createStore(rootReducer, applyMiddleware(myLogger));

export default store;


